import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';

export function RentalVehicles() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode="rental-vehicle-os"
      data-testid={testIds.vehicles.rentalVehicleOverview()}
      // eslint-disable-next-line no-restricted-syntax
      key="rental-vehicle-opensearch"
      actionCallback={actionCallback}
    />
  );
}
